export const ClientsTypes = {
  EMPLOYEE: 'Employee',
  CLIENT: 'Client',
  IB_CLIENT: 'IB Client',
};
